export default __webpack_public_path__ + "static/img5h-061f7443cd53c927b0dd04a5f73d1b2f.jpg";